export let white = [255, 255, 255]
export let albescent = [210, 210, 210]
export let coal = [40, 40, 40]
export let darkCoal = [20, 20, 20]
export let black = [0, 0, 0]
